// extracted by mini-css-extract-plugin
module.exports = {"btn":"_502c","outlined":"_7a38"};